<div class="text has-text-left">
    <modal [title]="title" [tagEventImp]="tagEventImp" [tagEventCTA]="tagEventCTA" [tagEventClose]="tagEventClose">
        <div>
            <p class="text">
                <strong>Vous voulez changer d'offre ?</strong>
                C'est possible depuis votre espace client.
            </p>
            <p class="text">
                <strong>Vous voulez une seconde offre Bbox pour un autre logement ?</strong>
                Un conseiller vous rappelle immédiatement pour vous accompagner.
            </p>
        </div>

        <div class="buttons mt-2">
            <button class="button is-loaded is-conversion" (click)="redirect()">Changer d'offre Bbox</button>
            <button class="button is-loaded is-secondary" (click)="redirectToCallBack()">
                Choisir une seconde offre Bbox
            </button>
        </div>
    </modal>
</div>
